import { initCommerceApiWithGlobals } from 'common-api';
import { isBrowser, logger, useAdobeBasketDetails } from 'common-ui';
import { useCartStore } from '../../../stores/cartStore';
import { useNotificationsStore } from '../../../stores/notificationsStore';
import { cartNotification } from '../../../helpers/cartNotification';

export function useAddToCartWithAtgLegacyApi() {
  const adobeBasketDetails = useAdobeBasketDetails();

  return async (productSku: string, quantity: string): Promise<void> => {
    try {
      const commerceApi = initCommerceApiWithGlobals();
      const newCartData = await commerceApi.Cart.add(productSku, quantity);
      useCartStore.getState().updateCart(prevState => ({
        ...prevState,
        cartIsLoaded: true,
        cartItems: {
          ...prevState.cartItems,
          ...newCartData,
        },
      }));
      const notification = cartNotification(productSku, quantity);
      useNotificationsStore.setState({ notifications: [notification] });

      if (isBrowser()) {
        const { pathname } = new URL(window.location.href);
        if (!pathname.startsWith('/cart')) {
          adobeBasketDetails();
        }
      }
    } catch (e) {
      logger.error('API ERROR', e);
      throw e;
    }
  };
}
